import * as React from "react";
import type { SVGProps } from "react";
const SvgShellAndCoreIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 28 28"
    {...props}
  >
    <path
      fill="#858585"
      d="M25.455 3H2.436A.516.516 0 0 0 2 3.524v20.952c0 .315.217.524.545.524h22.91c.328 0 .545-.209.545-.524V3.524c0-.315-.217-.524-.546-.524M3.09 14.524h6.545v4.19H3.091zm10.363-1.048H6.91v-4.19h6.546zm-2.727 1.048h6.546v4.19h-6.546zm3.819-1.048v-4.19h6.545v4.19zm10.363 0h-2.727v-4.19h2.727zm-6.545-9.428h6.545v4.19h-6.545zm-7.637 0h6.546v4.19h-6.546zm-7.636 0h6.545v4.19H3.091zm0 5.238h2.727v4.19H3.091zm2.727 14.666H3.091v-4.19h2.727zm7.637 0H6.908v-4.19h6.546zm7.636 0h-6.546v-4.19h6.546zm3.818 0h-2.727v-4.19h2.727zm0-5.238h-6.545v-4.19h6.545z"
    />
  </svg>
);
export default SvgShellAndCoreIcon;
